import React from 'react';
import {
  ListItem,
  ListItemIcon,
  TableCell,
  TableCellProps,
  Typography,
  SxProps,
  Theme,
} from '@mui/material';
import { darken } from '@mui/material/styles';
import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material';
import LightTooltip from 'src/components/LightTooltip';
import InfoIcon from '@mui/icons-material/Info';

interface Props {
  text: string;
  info?: string | React.ReactElement;
  collapsed: boolean;
  // eslint-disable-next-line no-unused-vars
  setCollapsed: (collapsed: boolean) => void;
  sx?: SxProps<Theme>;
}

export default function CollapsableButtonCell(props: TableCellProps & Props) {
  const { text, info, collapsed, setCollapsed, ..._props } = props;
  const handleCollapseClick = () => setCollapsed(!collapsed);
  const CollapseIcon = collapsed ? KeyboardArrowRight : KeyboardArrowDown;
  const bgColor = (_props.sx as { bgcolor?: string })?.bgcolor || '#fff';
  return (
    <TableCell
      {..._props}
      onClick={handleCollapseClick}
      sx={{
        cursor: 'pointer',
        ':hover': {
          bgcolor: darken(bgColor, 0.1),
          borderColor: darken(bgColor, 0.1),
        },
        ..._props.sx,
      }}
    >
      <ListItem>
        <ListItemIcon sx={{ minWidth: '32px' }}>
          <CollapseIcon />
        </ListItemIcon>
        <Typography variant="h6">{text}</Typography>
        &nbsp;
        {info && (
          <LightTooltip
            title={<span style={{ whiteSpace: 'pre-line' }}>{info}</span>}
          >
            <InfoIcon sx={{ fontSize: '18px' }} />
          </LightTooltip>
        )}
      </ListItem>
    </TableCell>
  );
}
